export default __webpack_public_path__ + "static/109-c31b35ad28bcb318c34f874539f5fb4a.jpg";